module.exports = __webpack_public_path__ + "static/img/service_wechat.fd1587e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service_wechat.png
// module id = cq+s
// module chunks = 1